import { createSelector } from '@reduxjs/toolkit';
import type { QueryParamsType, State } from '../types.js';
import { t } from 'src/i18n';

export function splitPath(state: State): string[] {
  try {
    return state.path.split('/');
  } catch {
    return [];
  }
}

function path(state: State): string {
  return state.path;
}

export const getCurrentPath = createSelector(path, function (path) {
  return path;
});

function queryParams(state: State): QueryParamsType {
  return state.queryParams || {};
}

export const showSubstancesUploader = createSelector(queryParams, (params) => params.showSubstancesUploader);

export const paramParentId = createSelector(queryParams, function (params) {
  return params.parent;
});

export const getFilterStartDate = createSelector(queryParams, (params) =>
  params.filterStartDate ? params.filterStartDate : '',
);

export const getFilterEndDate = createSelector(queryParams, (params) =>
  params.filterEndDate ? params.filterEndDate : '',
);

export const getFilterPeople = createSelector(queryParams, (params): string[] =>
  params.filterPeople ? JSON.parse(params.filterPeople) : [],
);

export const getFilterOn = createSelector(queryParams, (params): string => params.filterOn ?? '');

export const isNewEventFromSuggestion = createSelector(
  queryParams,
  (params): boolean => params.newEventFromSuggestion === 'true',
);

export const currentPathArray = splitPath;

export const currentPageId = createSelector(splitPath, (a) => {
  if (a.length < 4) return undefined;
  return Number(a[3]);
});
export const currentOrganizationId = createSelector(splitPath, (a) => {
  if (a.length < 3) return undefined;
  return Number(a[2]);
});

export const currentEntityType = createSelector(splitPath, (a) => {
  if (a.length < 6) return undefined;
  return a[a.length - 2];
});

export const currentEntityId = createSelector(splitPath, (a) => {
  if (a.length < 6) return undefined;
  const element = a[a.length - 1];
  return element.split(':')[0];
});

export const currentEntityInstance = createSelector(splitPath, (a) => {
  if (a.length < 6) return undefined;
  const element = a[a.length - 1];
  return element.split(':')[1] ?? '';
});

export const currentEntityTypeName = createSelector(currentEntityType, function (type) {
  if (type === 'employees') return t('entityTypeNames.employees');
  if (type === 'partners') return t('entityTypeNames.partners');
  if (type === 'contacts') return t('entityTypeNames.contacts');
  if (type === 'assets') return t('entityTypeNames.assets');
  if (type === 'constitutionalDocuments') return t('entityTypeNames.constitutionalDocuments');
  if (type === 'functions') return t('entityTypeNames.functions');
  if (type === 'tasks') return t('entityTypeNames.tasks');
  if (type === 'guidelines') return t('entityTypeNames.guidelines');
  if (type === 'documents') return t('entityTypeNames.documents');
  if (type === 'contracts') return t('entityTypeNames.contracts');
  if (type === 'reports') return t('entityTypeNames.reports');
  if (type === 'issues') return t('entityTypeNames.issues');
  if (type === 'riskAssessments') return t('entityTypeNames.riskAssessments');
  if (type === 'events') return t('entityTypeNames.events');
  return '';
});

export const currentEntityTypeNameDetermined = createSelector(currentEntityType, function (type) {
  if (type === 'employees') return t('entityTypeNamesDetermined.employees');
  if (type === 'partners') return t('entityTypeNamesDetermined.partners');
  if (type === 'contacts') return t('entityTypeNamesDetermined.contacts');
  if (type === 'assets') return t('entityTypeNamesDetermined.assets');
  if (type === 'constitutionalDocuments') return t('entityTypeNamesDetermined.constitutionalDocuments');
  if (type === 'functions') return t('entityTypeNamesDetermined.functions');
  if (type === 'tasks') return t('entityTypeNamesDetermined.tasks');
  if (type === 'guidelines') return t('entityTypeNamesDetermined.guidelines');
  if (type === 'documents') return t('entityTypeNamesDetermined.documents');
  if (type === 'contracts') return t('entityTypeNamesDetermined.contracts');
  if (type === 'reports') return t('entityTypeNamesDetermined.reports');
  if (type === 'issues') return t('entityTypeNamesDetermined.issues');
  if (type === 'riskAssessments') return t('entityTypeNamesDetermined.riskAssessments');
  if (type === 'events') return t('entityTypeNamesDetermined.events');
  return '';
});
